var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighRiskCs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "9t0lm3u4ea",
    d: "M0 0h17.5v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.277)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aunhflhcub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9t0lm3u4ea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.001 17.5a.5.5 0 0 0-.5-.5 4.505 4.505 0 0 1-4.5-4.5.5.5 0 0 0-1 0 5.505 5.505 0 0 0 5.5 5.5.5.5 0 0 0 .5-.5zm7-5a7.513 7.513 0 0 1-2.5 5.59A7.413 7.413 0 0 1 7.514 20 7.495 7.495 0 0 1 4.502 5.634v-.632a1.5 1.5 0 0 1 1.5-1.5H7.02C7.15 1.59 8.036.503 9.5.503a2.68 2.68 0 0 1 2.007.882c.504.467.939.87 2.41.625a.5.5 0 0 1 .165.986c-1.955.326-2.675-.341-3.254-.877a1.7 1.7 0 0 0-1.328-.616c-1.062 0-1.404.997-1.48 2H9a1.502 1.502 0 0 1 1.5 1.5v.632A7.544 7.544 0 0 1 15 12.5zm.548-10.93a.498.498 0 0 0 .286-.091l.819-.574a.5.5 0 0 0-.574-.819l-.819.574a.5.5 0 0 0 .288.91zm.286 1.957a.5.5 0 0 0-.574.818l.82.574a.5.5 0 0 0 .573-.819l-.819-.573zM17.5 2.503a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5z",
    fill: "#AEB3B7",
    mask: "url(#aunhflhcub)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskCs);
export default __webpack_public_path__ + "static/media/high-risk-cs.cfaaa0010232f9564b53db0db78c13b9.svg";
export { ForwardRef as ReactComponent };